<template>
    <div>
        <v-app>
            <router-view></router-view>
        </v-app>
    </div>
</template>

<script>
export default {
  name: 'App'
};
</script>
<style>
    .content {
        min-height: calc(100vh - 48px);
    }
</style>
